module.exports = __webpack_public_path__ + "img/post-views.f109d7d0.png";